import React, { useState } from 'react';
import { LazyImage, Button, Swiper, Container } from '@teko/ui';
import styled from '@emotion/styled';
import SwiperCore, { Thumbs } from 'swiper/core';
import { FrameWrapper } from '../FrameWrapper/FrameWrapper.es.js';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;
  width: 100%;
  height: 100%;
  background: #ffffff;
`;
const Footer = styled.div`
  bottom: 1rem;
  position: fixed;
  z-index: 3;
  height: fit-content !important;
  padding-bottom: env(safe-area-inset-bottom);
  .swiper-slide {
    width: auto !important;
  }
  .gallery-thumbs .swiper-slide {
    width: 25%;
    height: 100%;
    opacity: 0.4;
  }

  .gallery-thumbs .swiper-slide-thumb-active {
    opacity: 1;
  }
`;
const StyledImage = styled(LazyImage)`
  background: #ffffff;
  position: initial;
  img {
    min-width: 100%;
    max-height: 100%;
  }
`;
const StyledSmallImage = styled(LazyImage)`
  background: #ffffff;
`;
const ImageWrapper = styled.div`
  border: 0;
  top: 0;
  bottom: 0;
  margin: auto;
`;
const StyledContainer = styled.div`
  height: calc(100vh - 130px);
  z-index: 4;
  width: 100%;
  > div,
  .swiper-container {
    height: 100%;
    width: 100%;
  }
  .swiper-wrapper {
    height: 100% !important;
    width: 100% !important;
  }
`;
const Thumbnail = styled.div`
  transition: 0.1s ease opacity;
  text-align: center;
  background-color: transparent;
  width: fit-content !important;
  background: #ffffff;
`;
const ButtonClose = styled(Button)`
  position: absolute;
  top: 0;
  left: 0;
  padding: 16px;
  z-index: 1030;
`;
const GalleryIndex = styled.div`
  position: absolute;
  right: 16px;
  top: 16px;
  padding: 6px 12px;
  border-radius: 17px;
  background-color: #f6f6f6;
  color: #848788;
  font-size: 14px;
  z-index: 1030;
`;
const ImageGallery = ({
  images,
  activeImageIndex,
  onClose,
  frame
}) => {
  SwiperCore.use([Thumbs]);
  const [thumbsSwiper, setThumbsSwiper] = useState(null);
  const [activeSlideIndex, setActiveSlideIndex] = useState(activeImageIndex || 0);
  return /* @__PURE__ */ React.createElement(Wrapper, null, onClose && /* @__PURE__ */ React.createElement(ButtonClose, {
    onClick: onClose,
    link: true,
    icon: { name: "close", size: 18, color: "#878787" }
  }), /* @__PURE__ */ React.createElement(GalleryIndex, null, activeSlideIndex + 1, " / ", images.length), /* @__PURE__ */ React.createElement(StyledContainer, null, /* @__PURE__ */ React.createElement(Swiper, {
    thumbs: { swiper: thumbsSwiper },
    onSlideChange: (swiper) => setActiveSlideIndex(swiper.activeIndex),
    initialSlide: activeImageIndex,
    slidesPerView: 1,
    slidesPerGroup: 1,
    className: "main-images"
  }, images.map((image, index) => /* @__PURE__ */ React.createElement(ImageWrapper, {
    key: index
  }, frame && /* @__PURE__ */ React.createElement(FrameWrapper, {
    frame
  }), /* @__PURE__ */ React.createElement(StyledImage, {
    contain: true,
    imageWidth: 800,
    src: image.imageUrl,
    alt: image.caption
  })))), !!images.length && /* @__PURE__ */ React.createElement(Footer, null, /* @__PURE__ */ React.createElement(Container, null, /* @__PURE__ */ React.createElement(Swiper, {
    className: "gallery-thumbs",
    slidesPerView: "auto",
    spaceBetween: 16,
    onSwiper: setThumbsSwiper,
    watchSlidesVisibility: true,
    watchSlidesProgress: true
  }, images.map((image, index) => /* @__PURE__ */ React.createElement(Thumbnail, {
    key: index
  }, /* @__PURE__ */ React.createElement(StyledSmallImage, {
    src: image.thumbnailUrl || image.imageUrl,
    alt: image.caption,
    contain: true,
    width: 60,
    height: 60,
    imageWidth: 150,
    borderRadius: 4
  }))))))));
};

export { ImageGallery };
